import { env } from "@/config/env";

/** Rewrites legacy direct blob SAS links to the BFF proxy route (same-origin, safer in browsers). */
export function normalizeArtifactDownloadUrl(
  url: string | undefined,
  reportId: string,
  kind: "preview" | "preview-excel" | "word" | "excel",
): string | undefined {
  if (!url) return undefined;
  if (!url.includes("blob.core.windows.net")) return url;

  const base = env.apiBaseUrl.replace(/\/$/, "");
  return `${base}/intake/download/${encodeURIComponent(reportId)}?kind=${kind}`;
}
